// Zentrale Firmendaten (sprachunabhängig). Alle Texte liegen in src/i18n/messages/.

export const COMPANY = {
  name: "Nieder-Eschbacher Pflegedienst GmbH",
  shortName: "Nieder-Eschbacher Pflegedienst",
  claim:
    "Einfühlsame, kompetente Betreuung zuhause für ein sorgenfreies Leben.",
  address: {
    street: "Konrad-Duden-Weg 3",
    zip: "60437",
    city: "Frankfurt am Main",
  },
  phone: "069 / 90509470",
  phoneRaw: "+496990509470",
  fax: "069 / 90506972",
  emergency: "0177 / 7202956",
  emergencyRaw: "+491777202956",
  emergencyAlt: "0157 / 36442746",
  // WhatsApp: Mobilnummer im internationalen Format, ohne Leer- und Sonderzeichen.
  // Leer lassen -> der WhatsApp-Button und alle Hinweise verschwinden vollstaendig.
  whatsapp: "0177 / 7202956",
  whatsappRaw: "491777202956",
  emergencyAltRaw: "+4915736442746",
  email: "info@ne-pflegedienst.de",
  siteUrl: "https://www.ne-pflegedienst.de",
  managingDirector: "Natalja Kaiser",
  taxNumber: "04724026093",
  registerCourt: "Amtsgericht Frankfurt am Main",
  registerNumber: "HRB 98796",
  // Datenschutzbeauftragte(r): Pflegedienste sind i. d. R. benennungspflichtig
  // (Art. 37 Abs. 1 lit. c DSGVO). Sobald benannt, hier eintragen; die
  // Datenschutzerklärung blendet den Abschnitt dann automatisch ein.
  dpo: null, // z. B. { name: "…", email: "datenschutz@ne-pflegedienst.de", phone: "…" }
  supervisoryAuthority: {
    name: "Hessisches Amt für Versorgung und Soziales Frankfurt, Betreuungs- und Pflegeaufsicht",
    street: "Walter-Möller-Platz 1",
    zip: "60439",
    city: "Frankfurt am Main",
    url: "https://rp-giessen.hessen.de/havs-frankfurt",
  },
  area: "Frankfurt am Main & Umgebung (Schwerpunkt Nieder-Eschbach)",
};

// Webdesign-Credit im Impressum (freiwillig, kein Pflichtbestandteil)
export const CREDIT = {
  name: "Thaeer Sukay",
  url: "https://thaeersukay.de/",
  label: "thaeersukay.de",
};

// Betrieb der Website: im Auftrag des Pflegedienstes durch den Anbieter,
// Rechenzentrum in Deutschland. Beide werden in der Datenschutzerklaerung
// als Auftragsverarbeiter benannt.
export const HOSTING = {
  operator: {
    name: "MintFolder AI UG (haftungsbeschränkt)",
    address: "Sudetenstraße 18, 35039 Marburg",
  },
  provider: {
    name: "IONOS SE",
    address: "Elgendorfer Straße 57, 56410 Montabaur",
    url: "https://www.ionos.de/terms-gtc/datenschutzerklaerung/",
  },
};

// Weg einer E-Mail an info@: Weiterleitungsdienst -> Postfach.
// Leere Werte blenden den Absatz in der Datenschutzerklaerung aus.
export const MAIL = {
  forwarder: {
    name: "ImprovMX Incorporated",
    address: "8 The Green STE D, Dover, Delaware, USA",
  },
  mailbox: {
    name: "1&1 Mail & Media GmbH (GMX)",
    address: "Montabaur, Deutschland",
  },
};

// Google-Bewertungen (Startseite). Gesamtwertung und Anzahl aus dem
// Google-Unternehmensprofil; items nur mit ECHTEN Bewertungen 1:1 befüllen
// (gefälschte Bewertungen sind nach § 5b UWG / Anhang Nr. 23c unzulässig).
export const GOOGLE_REVIEWS = {
  rating: 4.8,
  count: 16,
  asOf: "September 2026",
  profileUrl:
    "https://www.google.com/maps/search/?api=1&query=Nieder-Eschbacher+Pflegedienst+GmbH+Konrad-Duden-Weg+3+60437+Frankfurt+am+Main",
  // Place-ID aus dem Google-Unternehmensprofil eintragen, dann erscheint der Button "Bewertung schreiben":
  // https://search.google.com/local/writereview?placeid=<PLACE_ID>
  writeUrl: "",
  items: [
    // { name: "M. K.", rating: 5, date: "2026-03", text: "…" },
  ],
};

